import { IProductBase } from '../../models/products';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

export type IDetailedProduct = IProductBase;

export const showProductsService = async (
  productId: string,
): Promise<IDetailedProduct> => {
  const { data } = await jhsfBookingsApi.get<IDetailedProduct>(
    `/products/${productId}`,
  );

  return data;
};
